import { ReactElement } from "react";
import Menu from "../../../Menu";
import ButtonHeader from "../../ButtonHeader";
import { Routes } from "@Front/Config/Routes";
import { getSuperAdminItems } from "../constants/superAdminItems";
import { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { isSuperAdminRole } from "@Front/Utils/officeRoleStatusHelpers";

interface SuperAdminMenuProps {
	permissionContext: PermissionContextDto | null;
	loadingPermissions: boolean;
}

function isSuperAdminUser(permissionContext: PermissionContextDto): boolean {
	const fromField = permissionContext.isSuperAdmin === true;
	const fromRole = isSuperAdminRole(permissionContext.globalRole);
	return fromField || fromRole;
}

export function SuperAdminMenu({ permissionContext, loadingPermissions }: SuperAdminMenuProps): ReactElement | null {
	if (loadingPermissions || !permissionContext || !isSuperAdminUser(permissionContext)) {
		return null;
	}
	const superAdminItems = getSuperAdminItems();
	return (
		<Menu items={superAdminItems} openingSide="center" openOnHover>
			<ButtonHeader
				text={"Espace super admin"}
				path={Routes.pages.Users.base}
				routesActive={superAdminItems.flatMap((item) => item.routesActive ?? [])}
				disabledLink
			/>
		</Menu>
	);
}
